<template>
  <base-modal
    hide-footer
    :size="'lg'"
    :modal-id="'transfer-stock'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
  >
    <template #modal-header>
      <div class="head-label">
        <b>Transfer : </b> {{ rewardDetail.name_en }}
      </div>
    </template>
    <b-row>
      <b-col
        cols="12"
        class="px-2"
      >
        <search :on-search-input="onSetValueSearch" />
      </b-col>
      <b-col
        cols="12"
        class="px-2 mt-2"
      >
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields"
              :items="inventoryList.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              class="default-static-table no-color-head normal-height height-modal"
            >
              <template #cell(actions)="data">
                <transfer-button
                  :btn-label="'Transfer'"
                  @click.native="selectInventory(data.item)"
                />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
    <b-row class="modal-body-container mb-1" />
  </base-modal>
</template>

<script>
import BaseModal from '@/@core/components/base-modal/BaseModal.vue'
import Search from '@/views/components/search/Search.vue'
import TransferButton from '@/views/components/button/TransferButton.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useTransferStock from '../hooks/useTransferStock'

export default {
  components: {
    BaseModal,
    Search,
    TransferButton,
    PaginationWithReorder,
  },
  props: {
    rewardDetail: { type: Object, default: {} },
  },
  setup(props) {
    const {
      pagination,
      inventoryList,
      fields,
      loading,
      onModalOpen,
      resolveStatusClass,
      resolveStatusLabel,
      onPageChange,
      onSetValueSearch,
      selectInventory,
    } = useTransferStock(props)
    return {
      pagination,
      inventoryList,
      fields,
      loading,
      onModalOpen,
      resolveStatusClass,
      resolveStatusLabel,
      onPageChange,
      onSetValueSearch,
      selectInventory,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/inventory/transfer-stock.css';
@import '~@/assets/css/pages/default-static-table.css';
</style>
